import { render, staticRenderFns } from "./roulette.vue?vue&type=template&id=e721015e&scoped=true"
import script from "./roulette.vue?vue&type=script&lang=js"
export * from "./roulette.vue?vue&type=script&lang=js"
import style0 from "./roulette.vue?vue&type=style&index=0&id=e721015e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e721015e",
  null
  
)

export default component.exports